import { EsgEligibilityIcon } from 'components/esg-eligibility/esg-eligibility-icon';
import { getEsgEligibilityTranslateMessageByEligibility } from 'components/esg-eligibility/utils';
import { FormattedMessage } from 'components/shared/Intl';
import type { EquityUnderlying } from 'models/underlying/equity';
import { FC, useContext } from 'react';
import { useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

export const Equity: FC<EquityUnderlying> = underlying => {
  const { bloombergTickerCode, bloombergComposite, isin, reutersCode, valorCode, website } = underlying;
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  const { formatMessage } = useIntl();

  const { esgEligibility, esgExtendedEligibility } = underlying ?? {};

  const eligibilityMessage = getEsgEligibilityTranslateMessageByEligibility(
    formatMessage,
    esgEligibility,
    esgExtendedEligibility,
  );

  return (
    <>
      {isin && (
        <>
          <dt>
            <FormattedMessage id="underlying.info.equity.isin" />:
          </dt>
          <dd>{isin}</dd>
        </>
      )}

      {bloombergTickerCode && (
        <>
          <dt>
            <FormattedMessage id="underlying.info.equity.bloombergCode" />:
          </dt>
          <dd>{bloombergTickerCode}</dd>
        </>
      )}

      {bloombergComposite && (
        <>
          <dt>
            <FormattedMessage id="underlying.info.equity.bloombergComposite" />:
          </dt>
          <dd>{bloombergComposite}</dd>
        </>
      )}

      {reutersCode && (
        <>
          <dt>
            <FormattedMessage id="underlying.info.equity.ricCode" />:
          </dt>
          <dd>{reutersCode}</dd>
        </>
      )}

      {valorCode && (
        <>
          <dt>VALOR CODE:</dt>
          <dd>{valorCode}</dd>
        </>
      )}

      {website && (
        <>
          <dt>
            <FormattedMessage id="underlying.info.equity.website" />:
          </dt>
          <dd>
            <a
              href={`https://${website}`}
              target="_blank"
              className="text-secondary fw-light"
              onClick={() => logAnalytics.trackEvent(logAnalyticsCategory, 'Underlying website')}
            >
              {website}
            </a>
          </dd>
        </>
      )}
      {Boolean(eligibilityMessage) && (
        <>
          <dt>
            <FormattedMessage id="underlying.info.equity.esgEligibility" />:
          </dt>
          <dd>
            <span className="flex-x gap-1 justify-content-end">
              <EsgEligibilityIcon
                size="xs"
                disabled
                isEligible={underlying.esgEligibility}
                isEligibleWithCondition={underlying.esgExtendedEligibility}
              />
              {eligibilityMessage}
            </span>
          </dd>
        </>
      )}
    </>
  );
};
